<app-window-title
  [closable]="true"
  [title]="mode === 'send' ? 'Invite Facility Owner' : 'Invite Facility'"
  (closed)="onCancel()"></app-window-title>

<!-- Success state -->
<ng-container *ngIf="invitationLink">
  <div mat-dialog-content style="padding: 24px">
    <div class="fx-col fx-gap-16">
      <div class="fx-row fx-ai-center fx-gap-8" style="color: #2e7d32">
        <mat-icon>check_circle</mat-icon>
        <span style="font-weight: 500">Invitation sent to {{ inviteForm.get('email')?.value }}</span>
      </div>
      <p style="margin: 0; font-size: 14px; color: #555">
        If the email doesn't arrive, share this link directly with the recipient:
      </p>
      <div class="link-box">
        <span class="link-text">{{ invitationLink }}</span>
        <button mat-icon-button (click)="copyLink()" matTooltip="Copy link">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px">content_copy</mat-icon>
        </button>
      </div>
      <p *ngIf="linkCopied" style="margin: 0; font-size: 13px; color: #2e7d32">Link copied to clipboard.</p>
    </div>
  </div>
  <div mat-dialog-actions class="fx-row fx-jc-end" style="padding: 16px 24px">
    <button mat-raised-button color="primary" (click)="onCancel()">Done</button>
  </div>
</ng-container>

<!-- Form state -->
<ng-container *ngIf="!invitationLink">
  <div mat-dialog-content style="padding: 24px">
    <form [formGroup]="inviteForm" class="fx-col fx-gap-20">

      <!-- Facility banner -->
      <div class="facility-info-section">
        <div class="fx-row fx-jc-start fx-ai-center fx-gap-8">
          <mat-icon style="color: #666; font-size: 20px; width: 20px; height: 20px">business</mat-icon>
          <div><strong>{{ facility.name }}</strong></div>
        </div>
        <div *ngIf="facility.address" class="fx-row fx-jc-start fx-ai-center fx-gap-8" style="margin-top: 4px">
          <mat-icon style="color: #999; font-size: 16px; width: 16px; height: 16px">location_on</mat-icon>
          <div style="font-size: 13px; color: #666">{{ facility.address }}</div>
        </div>
      </div>

      <!-- Name (send mode only) -->
      <mat-form-field *ngIf="mode === 'send'" appearance="outline" style="width: 100%">
        <mat-label>Full name</mat-label>
        <mat-icon matPrefix style="margin-right: 8px">person</mat-icon>
        <input matInput type="text" formControlName="name"
               placeholder="Jane Smith" [disabled]="sending">
        <mat-error *ngIf="inviteForm.get('name')?.hasError('required')">Name is required</mat-error>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Email address</mat-label>
        <mat-icon matPrefix style="margin-right: 8px">email</mat-icon>
        <input matInput type="email" formControlName="email"
               [placeholder]="mode === 'send' ? 'owner@facility.com' : 'email@example.com'"
               [disabled]="sending">
        <mat-error *ngIf="inviteForm.get('email')?.hasError('required')">Email is required</mat-error>
        <mat-error *ngIf="inviteForm.get('email')?.hasError('email')">Enter a valid email address</mat-error>
      </mat-form-field>

      <!-- Info note (send mode) -->
      <div *ngIf="mode === 'send'" class="info-message">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: #1976d2">info</mat-icon>
        <span>
          An invitation email will be sent. The recipient will complete account setup — including phone verification — via the link in the email.
        </span>
      </div>

    </form>
  </div>

  <div mat-dialog-actions class="fx-row fx-jc-end fx-ai-center fx-gap-12" style="padding: 16px 24px">
    <button mat-button (click)="onCancel()" [disabled]="sending">Cancel</button>
    <button mat-raised-button color="primary"
            (click)="onSend()"
            [disabled]="sending || inviteForm.invalid">
      <mat-progress-spinner *ngIf="sending" diameter="18"
                            style="display:inline-block; margin-right:4px"></mat-progress-spinner>
      <mat-icon *ngIf="!sending" style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">send</mat-icon>
      {{ sending ? 'Sending…' : 'Send invitation' }}
    </button>
  </div>
</ng-container>
